export enum ResetPasswordSelection {
  SendLink = 'SendLink',
  ManualReset = 'ManualReset'
}
